import React from "react";
import { PageHero } from "../components/PageHero";
import { PodIntroduction } from "../components/PodIntroduction";
import { PodPhilosophy } from "../components/PodPhilosophy";
import { PodComposition } from "../components/PodComposition";
import { PodLifecycle } from "../components/PodLifecycle";
import { PodStandards } from "../components/PodStandards";

export const Pods = () => {
  return (
    <div>
      <PageHero
        title="Pod-Based Excellence"
        subtitle="Discover our revolutionary Pod system that combines African talent with proven methodologies to deliver exceptional results. Our pods are purpose-built teams that honor talent, create value, and build lasting relationships."
      />

      <PodIntroduction />
      <PodPhilosophy />
      <PodComposition />
      <PodLifecycle />
      <PodStandards />
    </div>
  );
};
